// Channel names + per-layout slot styles for the persistent search map.
// The map node fills its slot 100%; the slot owns positioning (former
// reusableMapStyles layout classes, relocated here). `theme.tokens.topbarHeightDesktop`
// mirrors the old var(--topbarHeightDesktop); breakpoints mirror 600/900/1200.
// Each slot style takes `{ inApp }` as its second argument: the app has no TopBar but keeps
// the BottomNav at every width, so the map starts at the top and stops above the BottomNav.

export const MAP_CHANNELS = {
  SEARCH: 'search',
  BOOKMARK: 'bookmark',
};

// Search page split at md (900-1199 px): the list column gets 60 % so two listing cards fit
// next to each other; the fixed map takes the rest. MainPanel and the map slot read these.
export const SEARCH_LIST_WIDTH_MD = '60%';
export const SEARCH_MAP_WIDTH_MD = '40%';

/**
 * Vertical position of a full-height map column next to the page chrome.
 * @param {import('@mui/material/styles').Theme} theme
 * @param {boolean} inApp
 * @returns {{ top: string | number, height: string }}
 */
const getChromeOffset = (theme, inApp) =>
  inApp
    ? { top: 0, height: `calc(100vh - ${theme.tokens.BottomBar_height})` }
    : {
        top: theme.tokens.topbarHeightDesktop,
        height: `calc(100vh - ${theme.tokens.topbarHeightDesktop})`,
      };

// former SearchPage.module.css .map — fixed map column over the reserved right space
const searchColumn = (theme, { inApp = false } = {}) => {
  const { top, height } = getChromeOffset(theme, inApp);
  return {
    position: 'fixed',
    top: 0,
    right: 0,
    width: '100%',
    height: 'calc(100vh - 80px)',
    [theme.breakpoints.up('sm')]: { width: '100%' },
    [theme.breakpoints.up('md')]: { width: SEARCH_MAP_WIDTH_MD },
    [theme.breakpoints.up('lg')]: { top, width: '38%', height },
  };
};

// former SearchPage.module.css .mapStoryblokComponent — in-flow sticky column.
// Fills its column (width 100%) rather than viewport units: the ModalInMobile panel is
// constrained to ~38% in searchPageContentStyles and the map fills that panel, so it is not
// centered with empty gaps (cf. fix 132f729fc). `top` is the topbar height so sticky engages.
const storyblok = (theme, { inApp = false } = {}) => ({
  width: '100%',
  height: '100%',
  [theme.breakpoints.up('md')]: {
    width: '100%',
    ...getChromeOffset(theme, inApp),
    position: 'sticky',
  },
});

// former BookmarkPage.module.css .bookmarkMap — fills its column (width 100%) rather than
// viewport units (cf. storyblok fix a66ab34e9): bookmarkPageStyles constrains the ModalInMobile
// panel to 50%/37.5% and the map fills that panel, so it is not centered with empty gaps.
// `position: sticky` keeps it in view while the list scrolls, matching the SearchPage map.
const bookmark = (theme, { inApp = false } = {}) => ({
  width: '100vw',
  height: '100vh',
  [theme.breakpoints.up('md')]: {
    position: 'sticky',
    width: '100%',
    ...getChromeOffset(theme, inApp),
  },
});

export const MAP_SLOT_LAYOUT_SX = { searchColumn, storyblok, bookmark };
